import React from 'react';
import { FaFacebookF } from 'react-icons/fa';
import { AiFillInstagram, AiFillLinkedin } from 'react-icons/ai';
import './BoardMember.scss';

const BoardMemberList = ({ name, position, imgUri, facebook, instagram, linkedin }) => {
    return (
        <div>
            <div className="boardmember-body">
                <div className="container">

                    <div className="card-wrapper">

                        <div className="cards">

                            <div className="card-image">
                                <img src={imgUri} alt="profile one" className="board-img" />
                            </div>

                            <ul className="social-icons">
                                <li>
                                    <a href={facebook}>
                                        <i className="fab fa-facebook-f"><FaFacebookF /></i>
                                    </a>
                                </li>
                                <li>
                                    <a href={instagram}>
                                        <i className="fab fa-instagram"><AiFillInstagram /></i>
                                    </a>
                                </li>

                                <li>
                                    <a href={linkedin}>
                                        <i className="fab fa-dribbble"><AiFillLinkedin /></i>
                                    </a>
                                </li>
                            </ul>

                            <div className="details">
                                <h2 className="board-member-name">{`Find ${name.split(' ')[1]} on`}</h2>
                            </div>

                        </div>

                    </div>
                </div>
                <div className="memeber-card-detail-section">
                    <div className="team-post">{name}</div>
                    <div className="">{position}</div>
                </div>
            </div>
        </div>
    );
};

export default BoardMemberList;
